import { render, staticRenderFns } from "./CategoriesMenu.vue?vue&type=template&id=472200ae&scoped=true&"
import script from "./CategoriesMenu.vue?vue&type=script&lang=js&"
export * from "./CategoriesMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesMenu.vue?vue&type=style&index=0&id=472200ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472200ae",
  null
  
)

export default component.exports